import AvailabilityModel from '@/models/AvailabilityModel'
import { isFuture, isPast, parseISO } from 'date-fns'

export const state = {}
export const mutations = {}
export const getters = {
  getAvailabilities: () => AvailabilityModel.all(),
  getActive: () =>
    AvailabilityModel.query()
      .where('end_time_in_local_tz', (time) => isFuture(parseISO(time)))
      .where('start_time_in_local_tz', (time) => isPast(parseISO(time)))
      .get(),
}
export const actions = {
  async fetchAvailabilities() {
    try {
      await AvailabilityModel.fetchForShop()
    } catch (error) {
      throw Error(error)
    }
  }, // fetchAvailabilities

  async fetchUpcomingAvailabilities() {
    try {
      const shopSlug = window.location.hostname.split('.')[0]
      await AvailabilityModel.indexUpcomingForShop(shopSlug)
    } catch (error) {
      throw Error(error)
    }
  }, // fetchUpcomingAvailabilities
}
